// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"1af11e75","339":"2e68f428","453":"9ddcec14","551":"ab326cbe","617":"1404c580","638":"bbb48333","640":"49226086","685":"1b8f8821","842":"c41c3a2b","884":"0917db65","994":"413104d6"}[chunkId] + ".chunk.js";
};